<template>
  <nav class="navbar">
    <div class="container navbar-list">
      <div class="portfolio">
        <span
          :class="['btn bnt-outline gradient', loaded ? '' : 'fade-gradient']"
          @click="showPorfolio"
        >
          <span>
            PORTFOLIO
          </span>
        </span>
      </div>
      <div class="who" v-if="isVisible">
        <svg
          class="name-dev"
          width="200px"
          viewBox="0 0 1115 147"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;"
        >
          <g id="f">
            <path
              id="f-short"
              d="M759.513,59.158l37.194,0"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M759.513,5l67.161,0"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              id="f-body"
              d="M757.611,32.575l0,109.284"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
          </g>
          <path
            id="d"
            d="M414.013,5.171c37.72,-0 68.344,30.624 68.344,68.344c0,37.72 -30.624,68.344 -68.344,68.344"
            style="fill:none;stroke:#ddd;stroke-width:10px;"
          />
          <g id="i">
            <circle
              cx="8.5"
              cy="30.302"
              r="3.5"
              style="fill:#ddd;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M8.5,60.354l-0,81.505"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
          </g>
          <g id="i1" serif:id="i">
            <g>
              <circle
                cx="1105.8"
                cy="30.302"
                r="3.5"
                style="fill:#ddd;stroke:#ddd;stroke-width:10px;"
              />
              <path
                d="M1105.8,60.354l-0,81.505"
                style="fill:none;stroke:#ddd;stroke-width:10px;"
              />
            </g>
          </g>
          <path
            id="l"
            d="M636.497,5.144l-0,136.715"
            style="fill:none;stroke:#ddd;stroke-width:10px;"
          />
          <g id="t">
            <path
              d="M962.071,6.206l-0,135.653"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M938.242,37.135l54.716,-0"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
          </g>
          <g id="t1" serif:id="t">
            <path
              d="M1042.99,6.206l-0,135.653"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M1019.16,37.135l54.716,-0"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
          </g>
          <g id="a">
            <path
              d="M180.658,134.628c-17.787,-0 -32.227,-14.441 -32.227,-32.227c0,-17.787 14.44,-32.227 32.227,-32.227"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M180.658,70.174c17.786,-0 32.227,14.44 32.227,32.227"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M213.315,138.74l-0,-73.068"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
          </g>
          <g id="a1" serif:id="a">
            <path
              d="M873.445,134.628c-17.786,-0 -32.226,-14.441 -32.226,-32.227c-0,-17.787 14.44,-32.227 32.226,-32.227"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M873.445,70.174c17.787,-0 32.227,14.44 32.227,32.227"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M906.102,138.74l0,-73.068"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
          </g>
          <g id="n">
            <path
              d="M319.644,102.401c-0,-17.787 -14.441,-32.227 -32.227,-32.227"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M287.417,70.174c-17.787,-0 -32.227,14.44 -32.227,32.227"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M255.048,139.407l0,-80.694"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M319.722,139.407l0,-40.639"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
          </g>
          <path
            id="e"
            d="M554.882,99.948l41.619,0c-0,0 -0.699,-40.193 -40.194,-40.193c-39.494,-0 -39.377,38.475 -39.377,39.377c-0,0.902 -0.06,42.727 42.727,42.727"
            style="fill:none;stroke:#ddd;stroke-width:10px;"
          />
          <g id="v">
            <path
              d="M40.162,60.659l40.975,81.2"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
            <path
              d="M96.335,108.573l19.779,-43.317"
              style="fill:none;stroke:#ddd;stroke-width:10px;"
            />
          </g>
        </svg>
      </div>
      <span class="menu-container" @mouseleave="showHideMenu = false">
        <div class="menu" @click="showHideMenu = !showHideMenu">
          <div class="btn btn-outline">
            <span>
              MENU
            </span>
            <div
              :class="['hamburger-menu pl-1', showHideMenu ? 'is-open' : '']"
            >
              <span></span>
              <span :class="[loaded ? '' : 'stay']"></span>
              <span></span>
            </div>
          </div>
        </div>
        <transition name="slide-fade">
          <div class="menu-list" v-show="showHideMenu">
            <div class="menu-nav">
              <ul class="nav-list v-list">
                <li
                  v-for="(item, index) in menuList"
                  :class="['nav-item', menuIndex == index ? 'active' : '']"
                  :key="index"
                  @click="scrtollTo(item, index)"
                >
                  <span>{{ item.name }}</span>
                </li>
              </ul>
              <div class="contacts">
                <a
                  class="txt-light email"
                  href="mailto:delfatti_ivan@icloud.com"
                  >delfatti_ivan@icloud.com</a
                >
                <div class="socials">
                  <ul class="social-list h-list mt-4">
                    <li class="social-item px-1">
                      <a
                        title="Ivan Del Fatti - Profilo Linkedin"
                        href="https://linkedin.com/in/ivandf"
                        rel="noreferrer"
                        target="_blank"
                      >
                        <svg
                          width="35px"
                          viewBox="0 0 1183 1183"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xml:space="preserve"
                          xmlns:serif="http://www.serif.com/"
                          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
                        >
                          <g>
                            <path
                              d="M1182.42,591.209c-0,326.513 -264.697,591.21 -591.21,591.21c-326.525,-0 -591.206,-264.697 -591.206,-591.21c0,-326.522 264.681,-591.209 591.206,-591.209c326.513,0 591.21,264.688 591.21,591.209"
                              style="fill:#ddd;"
                            />
                            <path
                              d="M629.41,535.487c2.915,-3.134 4.05,-4.094 4.865,-5.278c39.732,-57.978 96.485,-75.025 162.7,-64.847c76.519,11.775 125.488,65.341 137.988,147.3c2.969,19.435 4.44,38.947 4.425,58.594c-0.044,81.603 -0.172,163.2 0.175,244.8c0.053,9.191 -2.21,11.887 -11.628,11.772c-42.747,-0.513 -85.516,-0.506 -128.272,-0c-9.353,0.106 -11.747,-2.563 -11.7,-11.766c0.35,-76.106 0.228,-152.209 0.15,-228.309c-0.028,-17.297 -1.216,-34.485 -6.078,-51.231c-15.585,-53.725 -76.707,-72.585 -120.232,-36.86c-23.515,19.291 -32.709,44.806 -32.531,74.835c0.381,71.79 0.113,143.578 0.113,215.368c-0,9.419 -0.525,18.866 0.159,28.228c0.6,8.138 -2.725,9.707 -10.097,9.657c-43.547,-0.294 -87.087,-0.325 -130.625,0.018c-7.903,0.06 -10.74,-1.543 -10.65,-10.231c0.638,-64.709 0.897,-129.447 0.922,-194.162c0.013,-79.641 -0.144,-159.272 -0.7,-238.903c-0.059,-8.719 1.766,-11.297 10.772,-11.197c43.547,0.487 87.087,0.415 130.628,0.047c7.841,-0.072 10.028,2.29 9.778,9.915c-0.54,16.41 -0.162,32.847 -0.162,52.25"
                              style="fill:#333;"
                            />
                            <path
                              d="M395.361,700.607c0,71.76 -0.153,143.525 0.185,215.291c0.034,8.909 -1.76,12.084 -11.475,11.956c-43.128,-0.575 -86.269,-0.441 -129.4,-0.081c-8.01,0.069 -10.71,-1.935 -10.7,-10.35c0.209,-144.71 0.172,-289.41 -0.041,-434.116c-0.009,-7.537 1.828,-10.056 9.738,-9.984c43.925,0.375 87.85,0.422 131.762,-0.031c8.766,-0.097 10.128,3.103 10.097,10.846c-0.269,72.163 -0.153,144.313 -0.166,216.469"
                              style="fill:#333;"
                            />
                            <path
                              d="M320.904,254.598c57.866,0.062 95.46,45.896 81.744,99.653c-10.362,40.59 -52.344,63.956 -100.8,56.09c-51.465,-8.353 -80.156,-58.581 -61.19,-107.122c11.837,-30.315 42.131,-48.668 80.246,-48.621"
                              style="fill:#333;"
                            />
                          </g>
                        </svg>
                      </a>
                    </li>
                    <li class="social-item px-1">
                      <a
                        title="Ivan Del Fatti - Profilo Codpen"
                        href="https://codepen.io/IvanDF"
                        rel="noreferrer"
                        target="_blank"
                      >
                        <svg
                          width="35px"
                          viewBox="0 0 6108 6109"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xml:space="preserve"
                          xmlns:serif="http://www.serif.com/"
                          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
                        >
                          <g id="Layer-1" serif:id="Layer 1">
                            <path
                              d="M3054.02,5606.46c-1407.43,0 -2552.43,-1145.04 -2552.43,-2552.43c-0,-1407.38 1145,-2552.43 2552.43,-2552.43c1407.38,-0 2552.38,1145.05 2552.38,2552.43c0,1407.4 -1145,2552.43 -2552.38,2552.43m0,-5606.46c-1686.73,0 -3054.02,1367.31 -3054.02,3054.02c-0,1686.73 1367.29,3053.99 3054.02,3053.99c1686.68,-0 3053.97,-1367.25 3053.97,-3053.99c-0,-1686.72 -1367.29,-3054.02 -3053.97,-3054.02"
                              style="fill:#ddd;fill-rule:nonzero;"
                            />
                            <path
                              d="M4617.76,3325.61l-405.99,-271.589l405.99,-271.575l0,543.164Zm-1401.47,1151.2l-0,-756.94l703.58,-470.547l567.956,379.844l-1271.54,847.643Zm-162.266,-1038.85l-574.01,-383.933l574.01,-383.932l573.958,383.932l-573.958,383.933Zm-162.318,1038.85l-1271.55,-847.643l568.008,-379.844l703.541,470.547l0,756.94Zm-1401.47,-1694.36l406.029,271.575l-406.029,271.589l-0,-543.164Zm1401.47,-1151.21l0,756.94l-703.541,470.651l-568.008,-379.961l1271.55,-847.63Zm324.584,-0l1271.54,847.63l-567.956,379.961l-703.58,-470.651l-0,-756.94Zm1724.61,826.276c-0.338,-2.383 -0.937,-4.661 -1.328,-7.044c-0.807,-4.584 -1.641,-9.154 -2.839,-13.62c-0.703,-2.682 -1.692,-5.26 -2.526,-7.839c-1.302,-3.984 -2.591,-7.955 -4.179,-11.823c-1.107,-2.682 -2.383,-5.364 -3.62,-7.942c-1.706,-3.685 -3.477,-7.266 -5.521,-10.729c-1.484,-2.592 -3.073,-5.079 -4.609,-7.552c-2.188,-3.386 -4.427,-6.667 -6.875,-9.844c-1.771,-2.383 -3.659,-4.766 -5.547,-7.058c-2.591,-2.968 -5.274,-5.95 -8.099,-8.736c-2.123,-2.175 -4.232,-4.362 -6.459,-6.355c-2.981,-2.682 -6.054,-5.273 -9.192,-7.747c-2.422,-1.888 -4.818,-3.776 -7.344,-5.56c-0.95,-0.599 -1.784,-1.393 -2.682,-1.992l-1726.07,-1150.7c-54.518,-36.354 -125.508,-36.354 -180.039,-0l-1726.06,1150.7c-0.898,0.599 -1.745,1.393 -2.682,1.992c-2.539,1.784 -4.922,3.672 -7.305,5.56c-3.177,2.474 -6.263,5.065 -9.179,7.747c-2.292,1.993 -4.375,4.18 -6.511,6.355c-2.825,2.786 -5.508,5.768 -8.047,8.736c-1.94,2.292 -3.828,4.675 -5.612,7.058c-2.382,3.177 -4.674,6.458 -6.81,9.844c-1.64,2.473 -3.177,4.96 -4.661,7.552c-1.992,3.463 -3.776,7.044 -5.521,10.729c-1.237,2.578 -2.526,5.26 -3.62,7.942c-1.588,3.868 -2.877,7.839 -4.179,11.823c-0.847,2.579 -1.784,5.157 -2.526,7.839c-1.198,4.466 -1.993,9.036 -2.839,13.62c-0.391,2.383 -0.989,4.661 -1.289,7.044c-0.95,6.953 -1.484,14.01 -1.484,21.159l-0,1150.7c-0,7.148 0.534,14.206 1.484,21.263c0.3,2.292 0.898,4.661 1.289,6.94c0.846,4.583 1.641,9.141 2.839,13.62c0.742,2.682 1.679,5.26 2.526,7.851c1.302,3.959 2.591,7.943 4.179,11.915c1.094,2.695 2.383,5.273 3.62,7.851c1.745,3.659 3.529,7.24 5.521,10.82c1.484,2.5 3.021,4.961 4.661,7.448c2.136,3.386 4.428,6.667 6.81,9.844c1.784,2.487 3.672,4.766 5.612,7.044c2.539,2.982 5.222,5.964 8.047,8.75c2.136,2.175 4.219,4.362 6.511,6.341c2.916,2.709 6.002,5.287 9.179,7.761c2.383,1.901 4.766,3.776 7.305,5.56c0.937,0.599 1.784,1.393 2.682,1.979l1726.06,1150.72c27.266,18.177 58.659,27.318 90.052,27.318c31.341,-0 62.721,-9.141 89.987,-27.318l1726.07,-1150.72c0.898,-0.586 1.732,-1.38 2.682,-1.979c2.526,-1.784 4.922,-3.659 7.344,-5.56c3.138,-2.474 6.211,-5.052 9.192,-7.761c2.227,-1.979 4.336,-4.166 6.459,-6.341c2.825,-2.786 5.508,-5.768 8.099,-8.75c1.888,-2.278 3.776,-4.557 5.547,-7.044c2.448,-3.177 4.687,-6.458 6.875,-9.844c1.536,-2.487 3.125,-4.948 4.609,-7.448c2.044,-3.58 3.815,-7.161 5.521,-10.82c1.237,-2.578 2.513,-5.156 3.62,-7.851c1.588,-3.972 2.877,-7.956 4.179,-11.915c0.834,-2.591 1.823,-5.169 2.526,-7.851c1.198,-4.479 2.032,-9.037 2.839,-13.62c0.391,-2.279 0.99,-4.648 1.328,-6.94c0.898,-7.057 1.458,-14.115 1.458,-21.263l0,-1150.7c0,-7.149 -0.56,-14.206 -1.458,-21.159"
                              style="fill:#ddd;fill-rule:nonzero;"
                            />
                          </g>
                        </svg>
                      </a>
                    </li>
                    <li class="social-item px-1">
                      <a
                        title="Ivan Del Fatti - Profilo Github"
                        href="https://github.com/IvanDF"
                        rel="noreferrer"
                        target="_blank"
                      >
                        <svg
                          width="35px"
                          viewBox="0 0 1067 1042"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xml:space="preserve"
                          xmlns:serif="http://www.serif.com/"
                          style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
                        >
                          <g>
                            <path
                              d="M533.338,3.465c-292.931,-0 -530.467,237.492 -530.467,530.467c-0,234.374 151.995,433.216 362.765,503.358c26.512,4.911 36.245,-11.507 36.245,-25.518c-0,-12.65 -0.492,-54.437 -0.721,-98.762c-147.576,32.089 -178.717,-62.588 -178.717,-62.588c-24.13,-61.315 -58.898,-77.619 -58.898,-77.619c-48.13,-32.923 3.628,-32.247 3.628,-32.247c53.268,3.742 81.316,54.665 81.316,54.665c47.312,81.097 124.096,57.651 154.367,44.097c4.761,-34.285 18.508,-57.686 33.679,-70.933c-117.824,-13.414 -241.683,-58.899 -241.683,-262.159c-0,-57.915 20.722,-105.236 54.656,-142.385c-5.508,-13.361 -23.665,-67.314 5.139,-140.382c-0,0 44.545,-14.257 145.916,54.375c42.314,-11.754 87.694,-17.648 132.775,-17.85c45.081,0.202 90.496,6.096 132.889,17.85c101.248,-68.632 145.731,-54.375 145.731,-54.375c28.875,73.068 10.709,127.021 5.201,140.382c34.013,37.149 54.594,84.47 54.594,142.385c0,203.743 -124.096,248.605 -242.218,261.737c19.027,16.462 35.98,48.744 35.98,98.235c0,70.977 -0.615,128.102 -0.615,145.574c0,14.116 9.549,30.657 36.438,25.448c210.656,-70.222 362.458,-268.993 362.458,-503.288c-0,-292.975 -237.502,-530.467 -530.458,-530.467Zm-331.79,755.661c-1.168,2.635 -5.315,3.426 -9.092,1.616c-3.847,-1.73 -6.008,-5.323 -4.761,-7.967c1.142,-2.714 5.297,-3.47 9.136,-1.651c3.856,1.73 6.052,5.358 4.717,8.002Zm26.093,23.283c-2.53,2.345 -7.475,1.256 -10.831,-2.451c-3.47,-3.698 -4.12,-8.644 -1.555,-11.025c2.609,-2.345 7.405,-1.247 10.884,2.451c3.47,3.742 4.146,8.653 1.502,11.025Zm17.901,29.789c-3.25,2.257 -8.565,0.14 -11.85,-4.577c-3.25,-4.717 -3.25,-10.374 0.07,-12.64c3.294,-2.267 8.53,-0.229 11.859,4.453c3.241,4.796 3.241,10.453 -0.079,12.764Zm30.274,34.5c-2.908,3.206 -9.101,2.345 -13.633,-2.029c-4.638,-4.278 -5.93,-10.348 -3.013,-13.555c2.942,-3.215 9.171,-2.31 13.738,2.03c4.603,4.269 6.009,10.383 2.908,13.554Zm39.126,11.647c-1.282,4.155 -7.247,6.043 -13.255,4.278c-6,-1.819 -9.926,-6.685 -8.714,-10.884c1.247,-4.181 7.238,-6.149 13.29,-4.261c5.991,1.81 9.927,6.641 8.679,10.867Zm44.528,4.94c0.149,4.375 -4.946,8.002 -11.253,8.082c-6.342,0.14 -11.472,-3.4 -11.542,-7.704c-0,-4.419 4.98,-8.012 11.323,-8.117c6.307,-0.123 11.472,3.391 11.472,7.739Zm43.743,-1.677c0.756,4.269 -3.628,8.653 -9.891,9.821c-6.158,1.124 -11.859,-1.511 -12.641,-5.745c-0.764,-4.374 3.699,-8.758 9.848,-9.891c6.272,-1.089 11.885,1.476 12.684,5.815Z"
                              style="fill:#ddd;fill-rule:nonzero;"
                            />
                          </g>
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      showHideMenu: false,
      loaded: false,

      isVisible: true,

      // menu list
      menuIndex: 0,
      menuList: [
        {
          name: "HOME",
          page: "home"
        },
        {
          name: "CHI SONO",
          page: "about"
        },
        {
          name: "CONTATTI",
          page: "contacts"
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.fadeIn();
    }, 1000);
    // animate scroll on click (menu)
    addEventListener("scroll", () => {
      if (window.scrollY < window.innerHeight / 3) {
        this.menuIndex = 0;
      } else if (window.scrollY <= window.innerHeight) {
        this.menuIndex = 1;
      } else if (window.scrollY == window.innerHeight * 2) {
        this.menuIndex = 2;
      }
    });
  },
  mounted() {
    // refs for ivan del fatti svg
    let nameDev = document.querySelector(".name-dev");
    let i = document.getElementById("i");
    let v = document.getElementById("v");
    let a = document.getElementById("a");
    let n = document.getElementById("n");
    let d = document.getElementById("d");
    let e = document.getElementById("e");
    let l = document.getElementById("l");
    let f = document.getElementById("f");
    let fShort = document.getElementById("f-short");
    let fBody = document.getElementById("f-body");
    let a1 = document.getElementById("a1");
    let t = document.getElementById("t");
    let t1 = document.getElementById("t1");
    let i1 = document.getElementById("i1");

    addEventListener("scroll", () => {
      if (window.scrollY / 5 >= 115) {
        nameDev.style.transform = "translate(-40%, -50%)";
        i.style.opacity = "1";
        i.style.transform = "translateX(36%)";
        v.style.opacity = "0";
        a.style.opacity = "0";
        n.style.opacity = "0";
        d.style.opacity = "1";
        d.style.transform = "translateX(0)";
        e.style.opacity = "0";
        l.style.opacity = "0";
        f.style.opacity = "1";
        f.style.transform = "translateX(-37.5%)";
        fShort.style.transform = "translateX(2.5%)";
        fBody.style.opacity = "0";
        a1.style.opacity = "0";
        t.style.opacity = "0";
        t1.style.opacity = "0";
        i1.style.opacity = "0";
      } else {
        nameDev.style.transform = "translate(-50%, -50%)";
        i.style.opacity = "1";
        i.style.transform = "translateX(0)";
        v.style.opacity = "1";
        a.style.opacity = "1";
        n.style.opacity = "1";
        d.style.opacity = "1";
        d.style.transform = "translateX(0)";
        e.style.opacity = "1";
        l.style.opacity = "1";
        f.style.opacity = "1";
        f.style.transform = "translateX(0)";
        fShort.style.transform = "translateX(0)";
        fBody.style.opacity = "1";
        a1.style.opacity = "1";
        t.style.opacity = "1";
        t1.style.opacity = "1";
        i1.style.opacity = "1";
      }
    });
  },
  methods: {
    scrtollTo(item, index) {
      this.menuIndex = index;
      if (item.name == this.menuList[index].name) {
        let el = document.getElementById(this.menuList[index].page);
        el.scrollIntoView({ behavior: "smooth" });
      }
      this.showHideMenu = false;
    },
    fadeIn() {
      this.loaded = !this.loaded;
    },
    showPorfolio() {
      // get cunter
      let counter = document.querySelector(".actual");
      // pages
      let aboutPage = document.getElementById("about");
      let porfolioPage = document.getElementById("portfolio");
      let passionsPage = document.getElementById("passions");

      // arrows
      let arrowPrev = document.querySelector(".arrow-prev");
      let arrowNext = document.querySelector(".arrow-next");

      // smooth scroll
      aboutPage.scrollIntoView({ behavior: "smooth" });

      // get who logo (navbar)
      let who = document.querySelector(".who");
      if (counter.innerHTML == 2) {
        setTimeout(() => {
          // show porfolio page
          counter.innerHTML = 1;
          porfolioPage.style.transform = "translateX(0)";
          // change arrow
          arrowPrev.style.visibility = "hidden";
          // modify who logo (navbar)
          who.style.opacity = "0";
          who.style.transform = "translateX(100px)";
        }, 950);
      } else if (counter.innerHTML == 3) {
        // show porfolio page
        passionsPage.style.transform = "translateX(100%)";
        counter.innerHTML = 1;
        // hide passions page
        porfolioPage.style.transform = "translateX(0)";
        // change arrows
        arrowNext.style.visibility = "visible";
        arrowPrev.style.visibility = "hidden";
        // modify who logo (navbar)
        who.style.opacity = "0";
        who.style.transform = "translateX(100px)";
      }
    }
  }
};
</script>

<style lang="scss">
// navbar
.navbar {
  @include center("fx-x");
  z-index: 10;
  width: 100%;
  .navbar-list {
    @include d-flex("spaceBtwn");
    padding: 20px 0;
  }
  .who {
    display: none;
    transition: opacity 350ms 350ms ease, transform 200ms 350ms linear;
    svg,
    g,
    path {
      transition: all 350ms ease;
      position: absolute;
    }
    svg {
      @include center("ab-xy");
    }
  }
  .menu {
    position: relative;
    z-index: 9;
  }
  .menu-list {
    position: absolute;
    z-index: 8;
    right: 0;
    top: 0;
    height: 100vh;
    width: 90%;
    box-shadow: -7px 0 5px rgba($black, 0.4);
    background: palette(2);
  }
  .hamburger-menu {
    margin-left: 5px;
  }
  .portfolio {
    .gradient {
      &.fade-gradient {
        background-position: 90% center;
        background-size: 200%;
      }
    }
  }
  .hamburger-menu {
    span {
      transition: transform 350ms ease-out;
      &:nth-child(2) {
        &.stay {
          transform: translateX(-11%);
        }
      }
    }
  }
}
// menu
.menu-nav {
  height: 100%;
  @include d-flex("center");
  flex-direction: column;
  .nav-list {
    @include d-flex("center");
    flex-grow: 1;
  }
  .contacts {
    position: absolute;
    @include d-flex("center");
    width: 100%;
    padding: 20px 0;
    bottom: 0;
    left: 0;
    flex-direction: column;
    &::after {
      content: "";
      @include center("ab-x");
      bottom: 57%;
      width: 150px;
      max-width: 90%;
      height: 2px;
      border-radius: 20px;
      background: palette(1);
    }
  }
}
.nav-item {
  padding: 15px 0;
  font-size: 2rem;
  &.active {
    span {
      color: palette(3);
      font-weight: 700;
    }
  }
  span {
    transition: color 200ms ease;
    &:hover:not(.active) {
      color: palette(3);
      --delay: calc((var(--char-index) + 1) * 400ms);
      animation: breathing 2000ms infinite both;
      animation-delay: var(--delay);
      cursor: pointer;
    }
  }
}
// menu items animate
@keyframes breathing {
  0% {
    font-variation-settings: "wght" 400;
  }
  60% {
    font-variation-settings: "wght" 700;
  }

  100% {
    font-variation-settings: "wght" 400;
  }
}
// mobile
@media screen and (min-width: 768px) {
  .navbar {
    .who {
      display: block;
    }
    .menu-list {
      width: 350px;
    }
  }
}

/* Vue transition */
.slide-fade-enter-active {
  transition: all 350ms ease;
}
.slide-fade-leave-active {
  transition: all 350ms cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(300px);
  opacity: 0;
}
</style>
